import axios from "axios";
import { Master_Service_TEAMS_URL } from "../Url";
import HashMap from "hashmap";
import { clearLogoutData } from "../logout/action";

var map = new HashMap();
var err;
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}
export const teamMasterActionsDetails = {
  TEAM_DETAIL_MASTER_SUCCESS: "TEAM_DETAIL_MASTER_SUCCESS",
  TEAM_DETAIL_MASTER_ERROR: "TEAM_DETAIL_MASTER_ERROR",
};

export function teamsDetailMaster(props) {
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Master_Service_TEAMS_URL}/get/partnerTeamDetailsMasters`,
      headers: {
        authorization: "Bearer " + props,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(teamsDetailMasterSuccess(response.data));

          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(teamsDetailMasterError(error));

          // return response;
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        }
      });
}

export function teamsDetailMasterError(error) {
  return {
    type: teamMasterActionsDetails.TEAM_DETAIL_MASTER_ERROR,
    payload: error,
  };
}

export function teamsDetailMasterSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: teamMasterActionsDetails.TEAM_DETAIL_MASTER_SUCCESS,
      payload: props,
    });
  };
}

export const getTeamsDetailActionsDetails = {
  GET_TEAM_DIRECTOR_DETAIL_SUCCESS: "GET_TEAM_DIRECTOR_DETAIL_SUCCESS",
  GET_TEAM_DIRECTOR_DETAIL_ERROR: "GET_TEAM_DIRECTOR_DETAIL_ERROR",
};

export function getTeamsDirectDetail(
  accessToken,
  partnerFirmId,
  partnerPersonId
) {
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Master_Service_TEAMS_URL}/getPartnerTeamDetails?partnerPersonId=${partnerPersonId}&partnerFirmId=${partnerFirmId}`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getTeamsDirectorDetailsSuccess(response.data));
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getTeamsDirectorDetailsError(error));

          // return response;
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        } else if (!err.response) {
        }
      });
}

export function getTeamsDirectorDetailsError(error) {
  return {
    type: getTeamsDetailActionsDetails.GET_TEAM_DIRECTOR_DETAIL_ERROR,
    payload: error,
  };
}

export function getTeamsDirectorDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getTeamsDetailActionsDetails.GET_TEAM_DIRECTOR_DETAIL_SUCCESS,
      payload: props,
    });
  };
}

export const getTeamsPanActions = {
  GET_TEAM_PAN_DETAIL_SUCCESS: "GET_TEAM_PAN_DETAIL_SUCCESS",
  GET_TEAM_PAN_DETAIL_ERROR: "GET_TEAM_PAN_DETAIL_ERROR",
};

export function getTeamsPanDetailAll(props) {
  const { access_token, personId } = props;

  return (dispatch) =>
    axios({
      method: "post",
      url: `${Master_Service_TEAMS_URL}/getPartnerTeamPanDetails?partnerPersonId=${personId}`,
      headers: {
        authorization: "Bearer " + access_token,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getTeamsPanDetailsSuccess(response.data));
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getTeamsPanDetailsError(error));

          // return response;
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        } else if (!err.response) {
        }
      });
}

export function getTeamsPanDetailsError(error) {
  return {
    type: getTeamsPanActions.GET_TEAM_PAN_DETAIL_ERROR,
    payload: error,
  };
}

export function getTeamsPanDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getTeamsPanActions.GET_TEAM_PAN_DETAIL_SUCCESS,
      payload: props,
    });
  };
}

export const getTeamsAadharActions = {
  GET_TEAM_AADHAR_DETAIL_SUCCESS: "GET_TEAM_AADHAR_DETAIL_SUCCESS",
  GET_TEAM_AADHAR_DETAIL_ERROR: "GET_TEAM_AADHAR_DETAIL_ERROR",
};

export function getTeamsAadharDetailAll(props) {
  const { access_token, personId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Master_Service_TEAMS_URL}/getPartnerTeamAadharDetails?partnerPersonId=${personId}`,
      headers: {
        authorization: "Bearer " + access_token,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getTeamsAadharDetailsSuccess(response.data));
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getTeamsAadharDetailsError(error));

          // return response;
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        } else if (!err.response) {
          // console.log(err);
        }
      });
}

export function getTeamsAadharDetailsError(error) {
  return {
    type: getTeamsAadharActions.GET_TEAM_AADHAR_DETAIL_ERROR,
    payload: error,
  };
}

export function getTeamsAadharDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getTeamsAadharActions.GET_TEAM_AADHAR_DETAIL_SUCCESS,
      payload: props,
    });
  };
}
